import { Box } from "@mui/joy";
import DarkTypography from "./DarkTypography";
import { WarningAmberRoundedIcon } from "../../styles/StyledMUI";
import { colorTokens } from "../../styles/globalStyles";

type ListRowAlertBannerProps = {
  labels: string[];
};

export default function ListRowAlertBanner({ labels }: ListRowAlertBannerProps) {
  if (labels.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        mb: 1,
        flexWrap: "wrap",
      }}
    >
      <WarningAmberRoundedIcon
        sx={{ color: colorTokens.status.danger, fontSize: 18, flexShrink: 0 }}
      />
      <DarkTypography
        level="body-sm"
        sx={{
          color: colorTokens.status.danger,
          fontWeight: 600,
          lineHeight: 1.2,
          wordBreak: "break-word",
        }}
      >
        {labels.join(" • ")}
      </DarkTypography>
    </Box>
  );
}
